import { render, staticRenderFns } from "./CaixaAberto.vue?vue&type=template&id=f9e8b79a&scoped=true"
import script from "./CaixaAberto.vue?vue&type=script&lang=js"
export * from "./CaixaAberto.vue?vue&type=script&lang=js"
import style0 from "./CaixaAberto.vue?vue&type=style&index=0&id=f9e8b79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e8b79a",
  null
  
)

export default component.exports